/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

import { tokens as Tokens } from "@/utils/tokens";
import { AUTH_TOKEN_NOT_VALID } from "@/constants";
import { ITokens } from "@/interfaces/User.interface";

const handleError = (error: any) => {
  const tokensInstance = Tokens;

  const userAuth: ITokens | undefined = queryClient.getQueryData(["user-auth"]);
  const { access: accessToken, refresh: refreshToken } = userAuth || {};
  
  if (tokensInstance.isTokenExpired(refreshToken)) {
    queryClient.invalidateQueries({queryKey:['user-auth']})
  }
  if (error.code === AUTH_TOKEN_NOT_VALID && !tokensInstance.isTokenExpired(accessToken)) {
    queryClient.invalidateQueries({queryKey:['user-auth']});
  }
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 1000, // 2 seconds,
      cacheTime: Infinity,
      retry: 1,
    },
  },
  queryCache: new QueryCache({
    onError: handleError,
  }),
  mutationCache: new MutationCache({
    onError: handleError,
  }),
});
